var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    clipPath: "url(#clip0_1035_14698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.8875 28V25.3333C22.8875 23.9188 22.3256 22.5623 21.3254 21.5621C20.3252 20.5619 18.9687 20 17.5542 20H6.88753C5.47304 20 4.11649 20.5619 3.1163 21.5621C2.1161 22.5623 1.5542 23.9188 1.5542 25.3333V28M30.8875 28V25.3333C30.8867 24.1516 30.4933 23.0037 29.7694 22.0698C29.0454 21.1358 28.0317 20.4688 26.8875 20.1733M21.5542 4.17333C22.7014 4.46707 23.7182 5.13427 24.4444 6.06975C25.1705 7.00523 25.5647 8.15577 25.5647 9.34C25.5647 10.5242 25.1705 11.6748 24.4444 12.6103C23.7182 13.5457 22.7014 14.2129 21.5542 14.5067M17.5542 9.33333C17.5542 12.2789 15.1664 14.6667 12.2209 14.6667C9.27535 14.6667 6.88753 12.2789 6.88753 9.33333C6.88753 6.38781 9.27535 4 12.2209 4C15.1664 4 17.5542 6.38781 17.5542 9.33333Z",
    stroke: "#0C4ACF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_14698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.220703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2f7200d35c9753daa54e666d642cb9c3.svg";
export { ForwardRef as ReactComponent };